<!-- <div class="container-fluid p-1 p-lg-3" [class.modal-view]="isModal">
  <div *ngIf="isModal" class="registration-header">
    <div class="header-left">
      <h2>Register {{ userType }}</h2>
    </div>

    <button *ngIf="isModal" mat-icon-button (click)="closeModal()" type="button" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div [attr.mat-dialog-content]="isModal ? '' : null" class="registration-body">

    <div class="row g-0 px-3 px-lg-5">

   
      <div class="col-lg-5 d-none d-lg-flex flex-column left-panel ">

      
        <div class="d-flex align-items-center gap-2 mb-5">
          <a *ngIf="!isModal" class="text-white  text-decoration-none me-1" style="font-size:1.2rem;"
            (click)="landingPage()"><i class="bi bi-arrow-left"></i></a>
          <span class="brand-logo"> <a class=" pe-3" (click)="landingPage()" style="cursor: pointer">
              <img src="logo/agrify-ai-white.png" class="img-fluid" />
            </a></span>
        </div>

        <h2 class="panel-title mb-4">Global Fruit Trade, Simplified.</h2>

        <div class="d-flex flex-column gap-3 mb-5">
          <div class="feature-item">
            <div class="feature-icon fi-green"><i class="bi bi-globe"></i></div>
            <div>
              <h6>Access Global Markets</h6>
              <p>Connect with verified buyers and sellers in over 120 countries instantly.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon fi-blue"><i class="bi bi-graph-up"></i></div>
            <div>
              <h6>AI-Driven Insights</h6>
              <p>Make smarter decisions with real-time price predictions and demand forecasting.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon fi-purple"><i class="bi bi-shield-shaded"></i></div>
            <div>
              <h6>Secure Transactions</h6>
              <p>Trade with confidence using our escrow services and smart contracts.</p>
            </div>
          </div>
        </div>

      
        <div class="mt-auto testimonial-card">
          <div class="stars mb-2">★★★★★</div>
          <p class="mb-3">"Agrify.ai revolutionized our export business. We found reliable buyers in Europe within our
            first week."</p>
          <div class="d-flex align-items-center gap-2">
            <div class="avatar">MR</div>
            <div>
              <div class="reviewer-name">Mateo Rodriguez</div>
              <div class="reviewer-role">FRUIT EXPORTER, CHILE</div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-12 col-lg-7 right-panel">
        <div style="max-width: 500px; width: 100%; margin: 0 auto;">

        
          <div class="d-flex d-lg-none align-items-center gap-2 mb-4">
            <span class="brand-logo"> <img src="logo/agrify-ai-blue.png" class="img-fluid" /></span>
          </div>

          <h2 class="form-title mb-1" *ngIf="currentStep === 1">Register here</h2>
          <h2 class="form-title mb-1" *ngIf="currentStep === 2">Account Details</h2>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <p class="form-subtitle mb-0">As a Buyer or Seller or Investor</p>
            <span class="step-label-v2 ">STEP {{currentStep}} OF 2</span>
          </div>

          <div class="step-bar-v2 mb-4">
            <div class="step-bar-fill-v2" [style.width]="(currentStep / 2) * 100 + '%'"></div>
          </div>

        
          <div class="step-panel" [class.active]="currentStep === 1" *ngIf="currentStep === 1"
            [formGroup]="firstFormGroup">

           
            <div class="row g-3 mb-3">
              <div class="col-12">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}">Select
                  Region <span class="text-danger">*</span></label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}"><i
                      class="bi bi-globe"></i></span>

                  <input type="text" placeholder="Search for country" class="f-input-v2" formControlName="region"
                    [matAutocomplete]="auto"
                    [ngClass]="{'is-invalid': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}">
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCountryChange($event.option.value)">
                    <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country.name">
                      {{country.name}}
                    </mat-option>
                  </mat-autocomplete>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="field-error-v2"
                  *ngIf="firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid">
                  Region is required.
                </div>
              </div>
            </div>


          
            <div class="row g-3 mb-3">
              <div class="col-12">
                <label class="form-label">Who are you?</label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"><i class="bi bi-person"></i></span>
                  <mat-select class="f-select-v2" formControlName="primaryPersona"
                    [ngClass]="{'is-invalid': firstFormGroup.get('primaryPersona')?.touched && firstFormGroup.get('primaryPersona')?.invalid}"
                    (selectionChange)="firstFormGroup.get('category')?.setValue(null)">
                    <mat-option value="buyer">Buyer</mat-option>
                    <mat-option value="seller">Seller</mat-option>
                    <mat-option value="investor">Investor</mat-option>
                  </mat-select>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
              </div>
            </div>

            
            <div class="row g-3 mb-4">
              <div class="col-12">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': (firstFormGroup.get('primaryPersona')?.value !== 'investor' && firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid) || (firstFormGroup.get('primaryPersona')?.value === 'investor' && firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid)}">
                  {{ firstFormGroup.get('primaryPersona')?.value === 'buyer' ? 'Buy' :
                  (firstFormGroup.get('primaryPersona')?.value === 'seller' ? 'Sell' : 'Type') }} <span
                    class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'}">
                    <i class="bi" [class.bi-basket]="firstFormGroup.get('primaryPersona')?.value !== 'investor'"
                      [class.bi-building]="firstFormGroup.get('primaryPersona')?.value === 'investor'"></i>
                  </span>
                  <mat-select class="f-select-v2" formControlName="category" placeholder="Select category"
                    [ngClass]="{'is-invalid': firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'}"
                    *ngIf="firstFormGroup.get('primaryPersona')?.value !== 'investor'">
                    <mat-option [value]="null">Select category</mat-option>
                    <ng-container *ngIf="firstFormGroup.get('primaryPersona')?.value === 'buyer'">
                      @if(firstFormGroup.get('region')?.value === 'India'){
                      <mat-option [value]="false">Locally (Trader/Retailer/Wholesaler)</mat-option>
                      }
                      <mat-option [value]="true">Globally (Importer/Merchant Trader)</mat-option>
                    </ng-container>
                    <ng-container *ngIf="firstFormGroup.get('primaryPersona')?.value === 'seller'">
                      @if(firstFormGroup.get('region')?.value === 'India'){
                      <mat-option [value]="false">Locally (Selling in India)</mat-option>
                      }
                      <mat-option [value]="true">Globally (Exporter)</mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-select class="f-select-v2" formControlName="orgSubType" placeholder="Select type"
                    [ngClass]="{'is-invalid': firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid}"
                    *ngIf="firstFormGroup.get('primaryPersona')?.value === 'investor'">
                    <mat-option value="">Select type</mat-option>
                    <mat-option value="privateCompany">Private Company</mat-option>
                    <mat-option value="publicCompany">Public Company</mat-option>
                    <mat-option value="financialInstitution">Financial Institution</mat-option>
                    <mat-option value="individual">Individual</mat-option>
                  </mat-select>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="field-error-v2"
                  *ngIf="firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'">
                  Category is required.
                </div>
                <div class="field-error-v2"
                  *ngIf="firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid && firstFormGroup.get('primaryPersona')?.value === 'investor'">
                  Type is required.
                </div>
              </div>
            </div>

           
            <div class="form-check mb-4">
              <input class="form-check-input" type="checkbox" id="termsStep1" formControlName="termsAccepted" />
              <label class="form-check-label-v2" for="termsStep1">
                I agree to the <a href="/pdfs/T&C.pdf" class="a-link-v2" target="_blank">Terms of Service</a> and <a
                  href="/pdfs/Privacy Policy.pdf" class="a-link-v2" target="_blank">Privacy Policy</a>.
              </label>

            </div>
            <div class="d-flex align-items-center gap-2 error-alert mb-3"
              *ngIf="firstFormGroup.get('termsAccepted')?.touched && firstFormGroup.get('termsAccepted')?.invalid">
              <i class="bi bi-exclamation-circle-fill fs-6"></i>
              <div>

                <div class="error-text">Please agree to the Terms of Service and Privacy Policy. </div>
              </div>
            </div>

            <button type="button" class="btn-submit-v2 w-100 mb-4" (click)="validateStep1()">
              NEXT <i class="bi bi-arrow-right ms-2"></i>
            </button>

            <p class="text-center auth-footer-text">
              Already registered? <a routerLink="/login" (click)="router.navigate(['/login'])"
                class="auth-link">Login</a>
            </p>
          </div>

       
          <div class="step-panel" [class.active]="currentStep === 2" *ngIf="currentStep === 2"
            [formGroup]="secondFormGroup">

          
            <div class="row g-3 mb-3">
              <div class="col-12">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}">Phone
                  Number <span class="text-danger">*</span></label>
                <div class="phone-input-group-v2">
                  <div class="country-selector-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}">
                    <img [src]="'https://flagcdn.com/w20/' + (countryCode || 'us') + '.png'" width="20" class="me-2" />
                    <span>+{{secondFormGroup.get('countryCode')?.value || '1'}}</span>
                    <i class="bi bi-chevron-down ms-1" style="font-size: 0.7rem;"></i>
                  </div>
                  <input type="number" class="f-input-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}"
                    placeholder="201 555 0123" formControlName="phoneNumber" />
                </div>
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid">
                  <span *ngIf="secondFormGroup.get('phoneNumber')?.errors?.['required']">Phone number is
                    required.</span>
                  <span *ngIf="secondFormGroup.get('phoneNumber')?.errors?.['pattern']">Invalid phone number.</span>
                </div>
              </div>
            </div>

           
            <div class="row g-3 mb-3">
              <div class="col-12 ">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}">Email
                  Address <span class="text-danger">*</span></label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}"><i
                      class="bi bi-envelope"></i></span>
                  <input type="email" class="f-input-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}"
                    placeholder="name@company.com" formControlName="emailId" />
                </div>
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid">
                  Valid email is required.
                </div>
              </div>
            </div>

           
            <div class="row g-3 mb-3">
              <div class="col-6">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid}">First
                  Name <span class="text-danger">*</span></label>
                <input type="text" class="f-input-v2 no-icon"
                  [ngClass]="{'is-invalid': secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid}"
                  placeholder="John" formControlName="firstName" />
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid">
                  Required.
                </div>
              </div>
              <div class="col-6">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid}">Last
                  Name <span class="text-danger">*</span></label>
                <input type="text" class="f-input-v2 no-icon"
                  [ngClass]="{'is-invalid': secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid}"
                  placeholder="Doe" formControlName="lastName" />
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid">
                  Required.
                </div>
              </div>
            </div>

         
            <div class="row g-3 mb-3">
              <div class="col-12">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}">Company
                  Name <span class="text-danger">*</span></label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}"><i
                      class="bi bi-building"></i></span>
                  <input type="text" class="f-input-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}"
                    placeholder="Agrify Solutions Inc." formControlName="companyName" />
                </div>
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid">
                  Company name is required.
                </div>
              </div>
            </div>

            <div class="row g-3 mb-4">
              <div class="col-6">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}">Password
                  <span class="text-danger">*</span></label>
                <div class="input-wrap-v2">
                  <input [type]="showPassword ? 'text' : 'password'" class="f-input-v2 no-icon pe-5"
                    [ngClass]="{'is-invalid': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}"
                    placeholder="••••••••" formControlName="password" />
                  <span class="i-right-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}"
                    (click)="togglePasswordVisibility()">
                    <i class="bi" [class.bi-eye-slash]="!showPassword" [class.bi-eye]="showPassword"></i>
                  </span>
                </div>
              </div>
              <div class="col-6">
                <label class="form-label"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}">Confirm
                  Password <span class="text-danger">*</span></label>
                <div class="input-wrap-v2">
                  <input [type]="showPassword ? 'text' : 'password'" class="f-input-v2 no-icon pe-5"
                    [ngClass]="{'is-invalid': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}"
                    placeholder="••••••••" formControlName="confirmPassword" />
                  <span class="i-right-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}"
                    (click)="togglePasswordVisibility()">
                    <i class="bi" [class.bi-eye-slash]="!showPassword" [class.bi-eye]="showPassword"></i>
                  </span>
                </div>
              </div>
              <div class="col-12 mt-1">
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid">
                  <div class="info-box-blue p-3 mb-4">
                    <div class="d-flex align-items-center gap-2 mb-2">
                      <i class="bi bi-check-circle-fill text-success"></i>
                      <span class="fw-bold" style="font-size: 0.85rem;color: black;">Password Requirements:</span>
                    </div>
                    <ul class="ps-4 mb-0 " style="font-size: 0.75rem; list-style-type: disc;color:#6E6E6E">
                      <li>At least 8 characters long</li>
                      <li>Contains uppercase and lowercase letters</li>
                      <li>Includes at least one number</li>
                      <li>Contains a special character (!@#$%^&*)</li>
                    </ul>
                  </div>
                </div>
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')">
                  Passwords do not match.
                </div>
              </div>
            </div>

          
            <div class="form-check mb-4">
              <input class="form-check-input" type="checkbox" id="termsStep2" checked disabled />
              <label class="form-check-label-v2" for="termsStep2">
                By continuing, you agree to Agrify's <a href="/pdfs/T&C.pdf" target="_blank" class="a-link-v2">Terms of
                  Use</a> and
                <a href="/pdfs/Privacy Policy.pdf" target="_blank" class="a-link-v2">Privacy Policy</a>. We value your
                data security.
              </label>
            </div>

            <button type="button" class="btn-submit-v2 w-100 mb-4" (click)="validateStep2()" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
              COMPLETE REGISTRATION <i class="bi bi-arrow-right ms-2"></i>
            </button>

            <p class="text-center auth-footer-text">
              Need to change previous info? <a href="javascript:void(0)" (click)="goBack()" class="auth-link">Go
                Back</a>
            </p>
          </div>

         
          <hr class="footer-divider">
         
          <div class="d-flex justify-content-between align-items-center mt-4 mb-2 flex-wrap gap-2">
            <span class="footer-copy">© 2024 Agrify.ai Inc.</span>
            <div class="footer-links d-flex gap-3">
              <a (click)="viewHelp()">Help</a>
              <a href="/pdfs/Privacy Policy.pdf" target="_blank">Privacy</a>
              <a href="/pdfs/T&C.pdf" target="_blank">Terms</a>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>


</div> -->
<div class="container-fluid p-0 p-sm-2 p-lg-3" [class.modal-view]="isModal">
  <div *ngIf="isModal"
    class="registration-header d-flex justify-content-between align-items-center w-100 px-3 pt-3 pb-2">
    <div class="header-left">
      <h2 class="m-0 fs-5">Register {{ userType }}</h2>
    </div>

    <button *ngIf="isModal" mat-icon-button (click)="closeModal()" type="button" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div [attr.mat-dialog-content]="isModal ? '' : null" class="registration-body p-0">

    <!-- Changed row spacing: g-0 removes side margins completely on mobile grids -->
    <div class="row g-0 px-2 px-lg-5">

      <!-- ── LEFT PANEL (hidden on mobile) ─────── -->
      <div class="col-lg-5 d-none d-lg-flex flex-column left-panel">
        <!-- Back + Logo -->
        <div class="d-flex align-items-center gap-2 mb-5">
          <a *ngIf="!isModal" class="text-white text-decoration-none me-1" style="font-size:1.2rem;"
            (click)="landingPage()">
            <i class="bi bi-arrow-left"></i>
          </a>
          <span class="brand-logo">
            <a class="pe-3" (click)="landingPage()" style="cursor: pointer">
              <img src="logo/agrify-ai-white.png" class="img-fluid" />
            </a>
          </span>
        </div>

        <!-- Headline -->
        <h2 class="panel-title mb-4">Global Fruit Trade, Simplified.</h2>

        <!-- Features -->
        <div class="d-flex flex-column gap-3 mb-5">
          <div class="feature-item">
            <div class="feature-icon fi-green"><i class="bi bi-globe"></i></div>
            <div>
              <h6>Access Global Markets</h6>
              <p>Connect with verified buyers and sellers in over 120 countries instantly.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon fi-blue"><i class="bi bi-graph-up"></i></div>
            <div>
              <h6>AI-Driven Insights</h6>
              <p>Make smarter decisions with real-time price predictions and demand forecasting.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon fi-purple"><i class="bi bi-shield-shaded"></i></div>
            <div>
              <h6>Secure Transactions</h6>
              <p>Trade with confidence using our escrow services and smart contracts.</p>
            </div>
          </div>
        </div>

        <!-- Testimonial -->
        <div class="mt-auto testimonial-card">
          <div class="stars mb-2">★★★★★</div>
          <p class="mb-3">"Agrify.ai revolutionized our export business. We found reliable buyers in Europe within our
            first week."</p>
          <div class="d-flex align-items-center gap-2">
            <div class="avatar">MR</div>
            <div>
              <div class="reviewer-name">Mateo Rodriguez</div>
              <div class="reviewer-role">FRUIT EXPORTER, CHILE</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── RIGHT PANEL (Form Box) ────────────────────────── -->
      <!-- Maximize mobile area: uses full width (col-12) with minimal internal margins -->
      <div class="col-12 col-lg-7 right-panel py-3 py-lg-4">
        <div class="form-max-container">

          <!-- Mobile logo (only shown on small screens) -->
          <div class="d-flex d-lg-none align-items-center gap-2 mb-3">
            <span class="brand-logo"><img src="logo/agrify-ai-blue.png" class="img-fluid"
                style="max-height: 40px;" /></span>
          </div>

          <h2 class="form-title mb-1 fs-4" *ngIf="currentStep === 1">Register here</h2>
          <h2 class="form-title mb-1 fs-4" *ngIf="currentStep === 2">Account Details</h2>

          <div class="d-flex justify-content-between align-items-center mb-1">
            <p class="form-subtitle mb-0 small text-muted">As a Buyer or Seller or Investor</p>
            <span class="step-label-v2 small fw-bold">STEP {{currentStep}} OF 2</span>
          </div>

          <div class="step-bar-v2 mb-3">
            <div class="step-bar-fill-v2" [style.width]="(currentStep / 2) * 100 + '%'"></div>
          </div>

          <!-- ══════════════════════════════ STEP 1 ══════════════════════════════ -->
          <div class="step-panel" [class.active]="currentStep === 1" *ngIf="currentStep === 1"
            [formGroup]="firstFormGroup">

            <!-- Region -->
            <div class="row g-2 mb-2">
              <div class="col-12">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}">
                  Select Region <span class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}">
                    <i class="bi bi-globe"></i>
                  </span>
                  <input type="text" placeholder="Search for country" class="f-input-v2" formControlName="region"
                    [matAutocomplete]="auto"
                    [ngClass]="{'is-invalid': firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid}">
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCountryChange($event.option.value)"
                    panelClass="custom-scrollable-panel">
                    <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country.name">
                      {{country.name}}
                    </mat-option>
                  </mat-autocomplete>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="firstFormGroup.get('region')?.touched && firstFormGroup.get('region')?.invalid">
                  Region is required.
                </div>
              </div>
            </div>

            <!-- Role -->
            <div class="row g-2 mb-2">
              <div class="col-12">
                <label class="form-label mb-1">Who are you?</label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"><i class="bi bi-person"></i></span>
                  <mat-select class="f-select-v2" formControlName="primaryPersona"
                    [ngClass]="{'is-invalid': firstFormGroup.get('primaryPersona')?.touched && firstFormGroup.get('primaryPersona')?.invalid}"
                    (selectionChange)="firstFormGroup.get('category')?.setValue(null)">
                    <mat-option value="buyer">Buyer</mat-option>
                    <mat-option value="seller">Seller</mat-option>
                    <mat-option value="investor">Financier</mat-option>
                  </mat-select>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
              </div>
            </div>

            <!-- Category -->
            <div class="row g-2 mb-3">
              <div class="col-12">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': (firstFormGroup.get('primaryPersona')?.value !== 'investor' && firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid) || (firstFormGroup.get('primaryPersona')?.value === 'investor' && firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid)}">
                  {{ firstFormGroup.get('primaryPersona')?.value === 'buyer' ? 'Buy' :
                  (firstFormGroup.get('primaryPersona')?.value === 'seller' ? 'Sell' : 'Type') }} <span
                    class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'}">
                    <i class="bi" [class.bi-basket]="firstFormGroup.get('primaryPersona')?.value !== 'investor'"
                      [class.bi-building]="firstFormGroup.get('primaryPersona')?.value === 'investor'"></i>
                  </span>
                  <mat-select class="f-select-v2" formControlName="category" placeholder="Select category"
                    [ngClass]="{'is-invalid': firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'}"
                    *ngIf="firstFormGroup.get('primaryPersona')?.value !== 'investor'">
                    <mat-option [value]="null">Select category</mat-option>
                    <ng-container *ngIf="firstFormGroup.get('primaryPersona')?.value === 'buyer'">
                      <mat-option *ngIf="firstFormGroup.get('region')?.value === 'India'" [value]="false">Locally
                        (Trader/Retailer/Wholesaler)</mat-option>
                      <mat-option [value]="true">Globally (Importer/Merchant Trader)</mat-option>
                    </ng-container>
                    <ng-container *ngIf="firstFormGroup.get('primaryPersona')?.value === 'seller'">
                      <mat-option *ngIf="firstFormGroup.get('region')?.value === 'India'" [value]="false">Locally
                        (Selling in India)</mat-option>
                      <mat-option [value]="true">Globally (Exporter)</mat-option>
                    </ng-container>
                  </mat-select>

                  <mat-select class="f-select-v2" formControlName="orgSubType" placeholder="Select type"
                    [ngClass]="{'is-invalid': firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid}"
                    *ngIf="firstFormGroup.get('primaryPersona')?.value === 'investor'">
                    <mat-option value="">Select type</mat-option>
                    <mat-option value="privateCompany">Private Company</mat-option>
                    <mat-option value="publicCompany">Public Company</mat-option>
                    <mat-option value="financialInstitution">Financial Institution</mat-option>
                    <mat-option value="individual">Individual</mat-option>
                  </mat-select>
                  <span class="select-chevron-v2"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="firstFormGroup.get('category')?.touched && firstFormGroup.get('category')?.invalid && firstFormGroup.get('primaryPersona')?.value !== 'investor'">
                  Category is required.
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="firstFormGroup.get('orgSubType')?.touched && firstFormGroup.get('orgSubType')?.invalid && firstFormGroup.get('primaryPersona')?.value === 'investor'">
                  Type is required.
                </div>
              </div>
            </div>

            <!-- T&C -->
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="termsStep1" formControlName="termsAccepted" />
              <label class="form-check-label-v2 small" for="termsStep1">
                I agree to the <a href="/pdfs/T&C.pdf" class="a-link-v2" target="_blank">Terms of Service</a> and <a
                  href="/pdfs/Privacy Policy.pdf" class="a-link-v2" target="_blank">Privacy Policy</a>.
              </label>
            </div>

            <div class="d-flex align-items-center gap-2 error-alert mb-3 p-2 small"
              *ngIf="firstFormGroup.get('termsAccepted')?.touched && firstFormGroup.get('termsAccepted')?.invalid">
              <i class="bi bi-exclamation-circle-fill"></i>
              <div class="error-text">Please agree to the Terms of Service and Privacy Policy.</div>
            </div>

            <button type="button" class="btn-submit-v2 w-100 mb-3 py-2" (click)="validateStep1()">
              NEXT <i class="bi bi-arrow-right ms-2"></i>
            </button>

            <p class="text-center auth-footer-text small mb-2">
              Already registered? <a routerLink="/login" (click)="router.navigate(['/login'])"
                class="auth-link">Login</a>
            </p>
          </div>

          <!-- ══════════════════════════════ STEP 2 ══════════════════════════════ -->
          <div class="step-panel" [class.active]="currentStep === 2" *ngIf="currentStep === 2"
            [formGroup]="secondFormGroup">

            <!-- Phone Number (Changed to type="tel" to fix native arrow glitches/zeros stripping) -->
            <div class="row g-2 mb-2">
              <div class="col-12">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}">
                  Phone Number <span class="text-danger">*</span>
                </label>
                <div class="phone-input-group-v2">
                  <div class="country-selector-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}">
                    <input type="text" formControlName="countryCode" class="country-code-input" [matAutocomplete]="countryCode" placeholder="Select country code"
                      [ngClass]="{'is-invalid': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}"
                      />
                    <mat-autocomplete #countryCode="matAutocomplete" (optionSelected)="onCountryCodeChange($event.option.value)" panelClass="custom-scrollable-panel">
                      <mat-option *ngFor="let country of filteredCountries2$|async" [value]="'+'+country.phonecode">
                        <img [src]="'https://flagcdn.com/w40/' + (country.isoCode | lowercase) + '.png'"
                          [alt]="country.name + ' flag'" class="country-flag-img" />
                        <span>{{country.phonecode}}</span>
                        <span>{{' '+country.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <input type="tel" inputmode="numeric" class="f-input-v2 f-phone-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid}"
                    placeholder="2015550123" formControlName="phoneNumber"
                    (keypress)="($event.charCode >= 48 && $event.charCode <= 57) || $event.preventDefault()" />
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="secondFormGroup.get('phoneNumber')?.touched && secondFormGroup.get('phoneNumber')?.invalid">
                  <span *ngIf="secondFormGroup.get('phoneNumber')?.errors?.['required']">Phone number is
                    required.</span>
                  <span *ngIf="secondFormGroup.get('phoneNumber')?.errors?.['pattern']">Invalid phone number.</span>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="row g-2 mb-2">
              <div class="col-12">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}">
                  Email Address <span class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}">
                    <i class="bi bi-envelope"></i>
                  </span>
                  <input type="email" class="f-input-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid}"
                    placeholder="name@company.com" formControlName="emailId" />
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="secondFormGroup.get('emailId')?.touched && secondFormGroup.get('emailId')?.invalid">
                  Valid email is required.
                </div>
              </div>
            </div>

            <!-- Names side-by-side -->
            <div class="row g-2 mb-2">
              <div class="col-6">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid}">
                  First Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="f-input-v2 no-icon"
                  [ngClass]="{'is-invalid': secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid}"
                  placeholder="John" formControlName="firstName" />
                <div class="field-error-v2 small mt-1"
                  *ngIf="secondFormGroup.get('firstName')?.touched && secondFormGroup.get('firstName')?.invalid">
                  Required.</div>
              </div>
              <div class="col-6">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid}">
                  Last Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="f-input-v2 no-icon"
                  [ngClass]="{'is-invalid': secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid}"
                  placeholder="Doe" formControlName="lastName" />
                <div class="field-error-v2 small mt-1"
                  *ngIf="secondFormGroup.get('lastName')?.touched && secondFormGroup.get('lastName')?.invalid">Required.
                </div>
              </div>
            </div>

            <!-- Company Name -->
            <div class="row g-2 mb-2">
              <div class="col-12">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}">
                  Company Name <span class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <span class="i-icon-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}">
                    <i class="bi bi-building"></i>
                  </span>
                  <input type="text" class="f-input-v2"
                    [ngClass]="{'is-invalid': secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid}"
                    placeholder="Agrify Solutions Inc." formControlName="companyName" />
                </div>
                <div class="field-error-v2 small mt-1"
                  *ngIf="secondFormGroup.get('companyName')?.touched && secondFormGroup.get('companyName')?.invalid">
                  Company name is required.
                </div>
              </div>
            </div>

            <!-- Passwords side-by-side -->
            <div class="row g-2 mb-2">
              <div class="col-6">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}">
                  Password <span class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <input [type]="showPassword ? 'text' : 'password'" class="f-input-v2 no-icon pe-4"
                    [ngClass]="{'is-invalid': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}"
                    placeholder="••••••••" formControlName="password" />
                  <span class="i-right-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid}"
                    (click)="togglePasswordVisibility()">
                    <i class="bi" [class.bi-eye-slash]="!showPassword" [class.bi-eye]="showPassword"></i>
                  </span>
                </div>
              </div>
              <div class="col-6">
                <label class="form-label mb-1"
                  [ngClass]="{'is-invalid-label': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}">
                  Confirm <span class="text-danger">*</span>
                </label>
                <div class="input-wrap-v2">
                  <input [type]="showPassword ? 'text' : 'password'" class="f-input-v2 no-icon pe-4"
                    [ngClass]="{'is-invalid': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}"
                    placeholder="••••••••" formControlName="confirmPassword" />
                  <span class="i-right-v2"
                    [ngClass]="{'is-invalid-icon': secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')}"
                    (click)="togglePasswordVisibility()">
                    <i class="bi" [class.bi-eye-slash]="!showPassword" [class.bi-eye]="showPassword"></i>
                  </span>
                </div>
              </div>

              <div class="col-12 mt-1">
                <div class="field-error-v2"
                  *ngIf="secondFormGroup.get('password')?.touched && secondFormGroup.get('password')?.invalid">
                  <div class="info-box-blue p-2 mb-2">
                    <div class="d-flex align-items-center gap-1 mb-1">
                      <i class="bi bi-info-circle-fill text-primary small"></i>
                      <span class="fw-bold small" style="color: black;">Password Rules:</span>
                    </div>
                    <ul class="ps-3 mb-0 text-muted" style="font-size: 0.7rem; list-style-type: disc;">
                      <li>Min 8 characters long</li>
                      <li>Upper & lowercase letters</li>
                      <li>At least one number & special character</li>
                    </ul>
                  </div>
                </div>
                <div class="field-error-v2 small"
                  *ngIf="secondFormGroup.get('confirmPassword')?.touched && secondFormGroup.hasError('passwordMismatch')">
                  Passwords do not match.
                </div>
              </div>
            </div>

            <!-- T&C for step 2 -->
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="termsStep2" checked disabled />
              <label class="form-check-label-v2 small" for="termsStep2">
                By continuing, you agree to Agrify's <a href="/pdfs/T&C.pdf" target="_blank" class="a-link-v2">Terms of
                  Use</a> and <a href="/pdfs/Privacy Policy.pdf" target="_blank" class="a-link-v2">Privacy Policy</a>.
              </label>
            </div>

            <button type="button" class="btn-submit-v2 w-100 mb-3 py-2" (click)="validateStep2()" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
              COMPLETE REGISTRATION <i class="bi bi-arrow-right ms-2"></i>
            </button>

            <p class="text-center auth-footer-text small">
              Need to change previous info? <a href="javascript:void(0)" (click)="goBack()" class="auth-link">Go
                Back</a>
            </p>
          </div>

          <hr class="footer-divider my-2">

          <!-- Footer -->
          <div class="d-flex justify-content-between align-items-center mt-2 mb-1 flex-wrap gap-1 small text-muted">
            <span class="footer-copy">© 2026 Agrify.ai Inc.</span>
            <div class="footer-links d-flex gap-2">
              <a (click)="viewHelp()">Help</a>
              <a href="/pdfs/Privacy Policy.pdf" target="_blank">Privacy</a>
              <a href="/pdfs/T&C.pdf" target="_blank">Terms</a>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>